/**
 * @desc 费用中心--费用概览/账单明细
 * @author 赵轮
 * @date 2023年10月24日14:33:26
 */
export default {
  火山语音费用: 'Cost Center',
  费用概览: 'Cost Overview',
  账单明细: 'Bill Details',
  火山通话记录: 'Volcano Call Log',
  火山号码月租: 'Volcano Number Monthly Rent',
  按明细: 'Details',
  按日: 'Daily',
  按月: 'Monthly',
  请选择人员: 'Please select person',
  时间: 'Time',
  通话量: 'Call volume',
  通话总费用: 'Total call cost',
  主叫通话时长: 'Caller duration',
  主叫计费时长: 'Caller billing duration',
  主叫通话费用: 'Caller cost',
  主叫号码: 'Caller phoneNumber',
  主叫号码归属地: 'Caller phoneNumber address',
  主叫侧外显号码: 'Caller display number',
  主叫外显号码池编号: 'Caller display number pool No',
  主叫外显号码池名称: 'Caller display number pool name',
  被叫号码: 'Callee phoneNumber',
  被叫计费时长: 'Callee billing duration',
  被叫通话费用: 'Callee cost',
  被叫号码归属地: 'Callee phoneNumber address',
  被叫侧外显号码: 'Callee display number',
  被叫外显号码池编号: 'Callee display number pool No',
  被叫外显号码池名称: 'Callee display number pool name',
  呼叫方向: 'Call direction',
  通话状态: 'Call status',
  通话员工: 'Call Employee',
  '火山-语音服务余额': 'Volcano-Voice service balance',
  '天眼查套餐（剩余次数/总次数）': 'TIANYANCHA Package（Remain Total/Total）',
  到期时间: 'Expiration time',
  数据更新时间: 'Data Update time',
  流水明细: 'Details',
  消费: 'Consume',
  充值: 'Recharge',
  '火山-语音服务': 'Volcano-Voice service',
  '天眼查-按次计费': 'TIANYANCHA-Pay per view',
  '天眼查-按套餐计费': 'TIANYANCHA-Package billing',
  请选择流水类型: 'Please select flow type',
  请选择业务类型: 'Please select business type',
  流水类型: 'Follow type',
  业务类型: 'Business Type',
  '变动金额（火山-语音服务）': 'Change amount（Volcano-Voice service）',
  '变动后余额（火山-语音服务）': 'Amount after change（Volcano-Voice service）',
  '变动套餐次数（天眼查）': 'Number of change packages（TIANYANCHA）',
  '套餐剩余次数（天眼查）': 'Remaining times of package（TIANYANCHA）',
  扣款时间: 'Deduction time',
  费用: 'Cost',
  扣款内容: 'Deduction content',
  号码: 'PhoneNumber',
  号码类型: 'PhoneNumber Type',
  归属地: 'Address',
  号码池编号: 'PhoneNumber pool No',
  号码池名称: 'PhoneNumber pool name',
  购买时间: 'Buy time'
};
